import {theme} from "../../../../../utils";

export const styles = {
    videoCardWrapper: {
        ...theme.components.shadowCard,
        maxWidth: "433px",
        height: "auto",
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    titleTextStyle: {
        ...theme.typography.montseratH1,
        fontSize: "14.29px",
        color: "#1E1E22",
        flex: 1
    },
    itemDesc: {
        ...theme.typography.components.sectionDescription,
        fontSize: "12px",
        color: "#393939",
        mt: "12px",
        lineHeight: "17.18px"
    },
    downloadLabelStyle: {
        ...theme.typography.montseratBodyRegular,
        fontSize: "11px",
        color: theme.palette.primary.main,
        textDecoration: "underline",
        textTransform: "capitalize"
    },
}
